import { CurrencySchema, InvoiceSchema, PAYMENT_TERMS } from '@weft/types';
import { oz } from '@weft/utils';

export const BillingCycleInvoiceSchema = InvoiceSchema.pick({
  id: true,
  name: true,
  revenueBreakdown: true,
  reviewStatus: true,
  billingStatus: true,
  billingCycle: true,
}).extend({
  invoiceNumber: oz.string().nonempty(),
  previousInvoiceAmount: oz.number().optional(),
  customerName: oz.string().nonempty(),
  erpDisplayId: oz.string().optional(),
  overcharges: oz.number().nonnegative(),
  currency: CurrencySchema,
  erpId: oz.string().nullish(),
  customerExternalId: oz.string().nonempty().optional(),
  paymentTerm: oz.nativeEnum(PAYMENT_TERMS),
  contractName: oz.string().optional(),
}).openapi('BillingCycleInvoice');

export type BillingCycleInvoice = oz.infer<typeof BillingCycleInvoiceSchema>;